import ImageKit from 'imagekit';
import { imagekitConfig } from '../config/imagekit.js';

const imagekit = new ImageKit({
  publicKey: imagekitConfig.publicKey,
  privateKey: imagekitConfig.privateKey,
  urlEndpoint: imagekitConfig.urlEndpoint,
});

export async function uploadImage(file) {
  if (!file) {
    throw new Error('No file provided');
  }

  const result = await imagekit.upload({
    file,
    fileName: file.name,
    folder: '/articles',
    tags: [file.name],
  });

  return result.url;
}
